var React = require('react');

function AlertLargeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-Designs","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Unum-Home-Page","transform":"translate(-120.000000, -24.000000)"},React.createElement("g",{"id":"Banner"},React.createElement("g",{"id":"Group-Copy","transform":"translate(120.000000, 24.000000)"},[React.createElement("circle",{"id":"Oval","fill":"#004470","cx":"26","cy":"26","r":"26","key":0}),React.createElement("text",{"id":"!","fontFamily":"Helvetica","fontSize":"34","fontWeight":"normal","lineSpacing":"32","fill":"#FFFFFF","key":1},React.createElement("tspan",{"x":"21","y":"39"},"!"))])))));
}

AlertLargeInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 52 52","version":"1.1"};

module.exports = AlertLargeInline;

AlertLargeInline.default = AlertLargeInline;
